import React, { useEffect, useState } from 'react';
import { Plus, Minus, X, Check, Trash2, ShoppingBag } from 'lucide-react';
import api from '../../api/client';

const fmt = (n) => `€${(n||0).toFixed(2)}`;
const STAMPA_EXTRA = 5;

export default function CatalogoCliente() {
  const [products, setProducts] = useState([]);
  const [righe, setRighe]       = useState([{ product_id:'', variant_id:'', quantita:1, stampa_nome:false, nome_stampa:'', note:'' }]);
  const [sending, setSending]   = useState(false);
  const [success, setSuccess]   = useState(false);
  const [warnings, setWarnings] = useState([]);
  const [noteOrdine, setNoteOrdine] = useState('');

  useEffect(() => {
    api.get('/products').then(r => setProducts(r.data)).catch(console.error);
  }, []);

  const getVariants = (pid) => products.find(p => p.id === parseInt(pid))?.variants?.filter(v => v.attiva) || [];
  const getProduct  = (pid) => products.find(p => p.id === parseInt(pid));
  const getPrezzo   = (pid) => getProduct(pid)?.prezzo_vendita_ivato || 0;
  const canStampa   = (pid) => getProduct(pid)?.personalizzabile || false;

  const updRiga = (idx, k, v) => setRighe(prev => prev.map((r, i) => {
    if (i !== idx) return r;
    const updated = { ...r, [k]: v };
    if (k === 'product_id') { updated.variant_id = ''; updated.stampa_nome = false; updated.nome_stampa = ''; }
    return updated;
  }));

  const addRiga    = () => setRighe(prev => [...prev, { product_id:'', variant_id:'', quantita:1, stampa_nome:false, nome_stampa:'', note:'' }]);
  const removeRiga = (idx) => setRighe(prev => prev.filter((_, i) => i !== idx));

  const totale = righe.reduce((s, r) => {
    if (!r.product_id || !r.variant_id) return s;
    return s + (getPrezzo(r.product_id) + (r.stampa_nome ? STAMPA_EXTRA : 0)) * r.quantita;
  }, 0);

  const righeValide = righe.filter(r => r.product_id && r.variant_id);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (righeValide.length === 0) { alert('Aggiungi almeno un articolo'); return; }
    if (righeValide.some(r => r.stampa_nome && !r.nome_stampa.trim())) {
      alert('Inserisci il nome da stampare per tutti gli articoli con stampa nome'); return;
    }
    setSending(true);
    try {
      const res = await api.post('/orders', {
        note: noteOrdine || null,
        items: righeValide.map(r => ({
          variant_id: parseInt(r.variant_id),
          quantita:   parseInt(r.quantita),
          note: [r.stampa_nome ? `STAMPA NOME: ${r.nome_stampa}` : '', r.note].filter(Boolean).join(' | ') || null,
        })),
      });
      setRighe([{ product_id:'', variant_id:'', quantita:1, stampa_nome:false, nome_stampa:'', note:'' }]);
      setNoteOrdine('');
      setSuccess(true);
      setWarnings(res.data?.warnings || []);
      setTimeout(() => { setSuccess(false); setWarnings([]); }, 8000);
    } catch(err) {
      alert(err.response?.data?.error || "Errore nell'invio dell'ordine");
    } finally { setSending(false); }
  };

  return (
    <div style={{ maxWidth:'900px' }}>
      <div style={{ marginBottom:'28px' }}>
        <h1 style={s.title}>NUOVO ORDINE</h1>
        <p style={s.sub}>Aggiungi gli articoli riga per riga, poi invia allo staff</p>
      </div>

      {success && (
        <div style={s.successBanner}>
          <Check size={16}/> Ordine inviato! Lo staff lo prenderà in carico a breve.
        </div>
      )}

      {warnings.length > 0 && (
        <div style={s.warningBanner}>
          Viste le quantità disponibili, alcuni articoli richiederanno più tempo prima di essere evasi:
          <ul style={{ margin:'6px 0 0', paddingLeft:'18px' }}>
            {warnings.map((w, i) => <li key={i}>{w}</li>)}
          </ul>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* RIGHE */}
        <div style={{ display:'flex', flexDirection:'column', gap:'10px', marginBottom:'16px' }}>
          {righe.map((riga, idx) => {
            const prod    = getProduct(riga.product_id);
            const variants = getVariants(riga.product_id);
            const prezzo  = getPrezzo(riga.product_id);
            const totRiga = (prezzo + (riga.stampa_nome ? STAMPA_EXTRA : 0)) * riga.quantita;

            return (
              <div key={idx} style={s.rigaCard}>
                <div style={{ display:'flex', gap:'10px', alignItems:'flex-end', flexWrap:'wrap' }}>
                  {/* Prodotto */}
                  <div style={{ flex:'2 1 200px', display:'flex', flexDirection:'column', gap:'5px' }}>
                    <label style={s.label}>PRODOTTO</label>
                    <select style={s.input} value={riga.product_id}
                      onChange={e => updRiga(idx, 'product_id', e.target.value)}>
                      <option value="">— seleziona prodotto —</option>
                      {products.filter(p => p.acquistabile !== false).map(p => (
                        <option key={p.id} value={p.id}>{p.nome}</option>
                      ))}
                    </select>
                  </div>

                  {/* Taglia */}
                  <div style={{ flex:'1 1 120px', display:'flex', flexDirection:'column', gap:'5px' }}>
                    <label style={s.label}>TAGLIA</label>
                    <select style={s.input} value={riga.variant_id}
                      onChange={e => updRiga(idx, 'variant_id', e.target.value)}
                      disabled={!riga.product_id}>
                      <option value="">— taglia —</option>
                      {variants.map(v => (
                        <option key={v.id} value={v.id}>
                          {v.taglia}{v.inventory?.quantita_disponibile > 0 ? ` (${v.inventory.quantita_disponibile} disp.)` : ' (su ord.)'}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Quantità */}
                  <div style={{ flex:'0 0 100px', display:'flex', flexDirection:'column', gap:'5px' }}>
                    <label style={s.label}>QTÀ</label>
                    <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                      <button type="button" style={s.qtyBtn} onClick={() => updRiga(idx, 'quantita', Math.max(1, riga.quantita-1))}><Minus size={12}/></button>
                      <span style={{ fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-xl)', fontWeight:'800', minWidth:'28px', textAlign:'center' }}>{riga.quantita}</span>
                      <button type="button" style={s.qtyBtn} onClick={() => updRiga(idx, 'quantita', riga.quantita+1)}><Plus size={12}/></button>
                    </div>
                  </div>

                  {/* Prezzo riga */}
                  <div style={{ flex:'0 0 90px', textAlign:'right' }}>
                    <div style={{ fontSize: 'var(--font-size-xs)', letterSpacing:'1px', fontWeight:'700', color:'var(--text-dim)', marginBottom:'4px' }}>TOTALE RIGA</div>
                    <div style={{ fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-xl)', fontWeight:'800', color: riga.product_id && riga.variant_id ? '#F4600C' : 'var(--text-dim)' }}>
                      {riga.product_id && riga.variant_id ? fmt(totRiga) : '—'}
                    </div>
                  </div>

                  {/* Elimina */}
                  {righe.length > 1 && (
                    <button type="button" style={s.delBtn} onClick={() => removeRiga(idx)}><Trash2 size={14}/></button>
                  )}
                </div>

                {/* Stampa nome + Note */}
                {riga.product_id && (
                  <div style={{ marginTop:'10px', display:'flex', gap:'12px', alignItems:'flex-start', flexWrap:'wrap' }}>
                    {canStampa(riga.product_id) && (
                      <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                        <label style={{ display:'flex', alignItems:'center', gap:'8px', cursor:'pointer', fontSize: 'var(--font-size-xs)', color: riga.stampa_nome ? '#F4600C' : '#777', fontWeight:'700' }}>
                          <input type="checkbox" checked={riga.stampa_nome}
                            onChange={e => updRiga(idx,'stampa_nome',e.target.checked)}
                            style={{ accentColor:'#F4600C', width:'15px', height:'15px' }}/>
                          STAMPA NOME (+€{STAMPA_EXTRA})
                        </label>
                        {riga.stampa_nome && (
                          <input style={{ ...s.input, width:'180px' }} value={riga.nome_stampa}
                            onChange={e => updRiga(idx,'nome_stampa',e.target.value)}
                            placeholder="Nome da stampare..."/>
                        )}
                      </div>
                    )}
                    <div style={{ flex:1, display:'flex', flexDirection:'column', gap:'5px', minWidth:'200px' }}>
                      <label style={s.label}>NOTE RIGA</label>
                      <input style={s.input} value={riga.note}
                        onChange={e => updRiga(idx,'note',e.target.value)}
                        placeholder="Note o richieste particolari..."/>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* AGGIUNGI RIGA */}
        <button type="button" style={s.addRigaBtn} onClick={addRiga}>
          <Plus size={14}/> AGGIUNGI ARTICOLO
        </button>

        {/* NOTE ORDINE */}
        {righeValide.length > 0 && (
          <div style={{ marginTop:'16px', display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={s.label}>NOTE GENERALI ORDINE</label>
            <input style={s.input} value={noteOrdine}
              onChange={e => setNoteOrdine(e.target.value)}
              placeholder="Note generali per lo staff..."/>
          </div>
        )}

        {/* RIEPILOGO + INVIA */}
        {righeValide.length > 0 && (
          <div style={s.riepilogo}>
            <div>
              <div style={{ fontSize: 'var(--font-size-xs)', color:'var(--text-dim)', fontWeight:'700' }}>{righeValide.length} ARTICOLI</div>
              <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800' }}>{fmt(totale)}</div>
            </div>
            <button type="submit" style={s.submitBtn} disabled={sending}>
              <ShoppingBag size={16}/>
              {sending ? 'INVIO IN CORSO...' : 'INVIA ORDINE ALLO STAFF'}
            </button>
          </div>
        )}
      </form>
    </div>
  );
}

const s = {
  title:       { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub:         { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginTop:'4px' },
  successBanner:{ display:'flex', alignItems:'center', gap:'10px', background:'#22C55E20', border:'1px solid #22C55E40', borderRadius:'10px', padding:'14px 18px', marginBottom:'20px', color:'#22C55E', fontWeight:'700', fontSize:'var(--font-size-sm)' },
  warningBanner:{ background:'#F59E0B15', border:'1px solid #F59E0B40', borderRadius:'10px', padding:'12px 18px', marginBottom:'20px', color:'#F59E0B', fontWeight:'600', fontSize:'var(--font-size-xs)' },
  rigaCard:    { background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'10px', padding:'16px' },
  label:       { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input:       { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'9px 12px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  qtyBtn:      { background:'var(--border)', border:'1px solid var(--border2)', borderRadius:'6px', padding:'7px 10px', color:'var(--text-muted)', cursor:'pointer', display:'flex', alignItems:'center' },
  delBtn:      { background:'#EF444415', border:'1px solid #EF444430', borderRadius:'8px', padding:'8px 10px', color:'#EF4444', cursor:'pointer', display:'flex', alignItems:'center', alignSelf:'flex-end' },
  addRigaBtn:  { display:'flex', alignItems:'center', gap:'8px', width:'100%', padding:'12px', background:'var(--bg-input)', border:'1px dashed var(--border2)', borderRadius:'10px', color:'var(--text-dim)', fontSize: 'var(--font-size-xs)', fontWeight:'700', cursor:'pointer', justifyContent:'center', marginTop:'4px' },
  riepilogo:   { display:'flex', justifyContent:'space-between', alignItems:'center', background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'16px 20px', marginTop:'20px' },
  submitBtn:   { display:'flex', alignItems:'center', gap:'10px', background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px 28px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer' },
};
